export class Routes {
    public static ENTERPRISE_UPDATE = '';
    public static ENTERPRISE_LOGIN = 'enterprise-login';
    public static ENTERPRISE_HOME = 'home-enterprise';
    public static ENTERPRISE_KYC = 'kyc';
    public static SLASH = '/';
    public static GET_PERMISSION_INFO = '/auth/permission-info';
    public static ANONYMOUS_LOGIN = '/anonymous/login';
    public static FORGOT_PASSWORD = '/auth/forgot-password';
    public static RESET_PASSWORD = '/auth/forgot-password';
    public static GET_LIST_CLOUD_CA = '/common/get-certificate';
    public static GET_CLOUD_CA = '/common/get-cert-cloud-ca';
    public static SEND_REQUEST = '/verify-account/verify-two-factor-internal';
    public static getResultSigning = '/verify-account/get-result-verify-two-factor';
}
